import { CalendarIcon, ListIcon } from '@calizahq/react-components-v2'
import clsx from 'clsx'
import React from 'react'

type Props = {
  calendarVisible: boolean
  toggle: () => void
}

const ViewToggle = ({ calendarVisible, toggle }: Props) => {
  const listVisible = !calendarVisible

  const onListViewToggle = () => {
    if (calendarVisible) {
      toggle()
    }
  }

  const onCalendarViewToggle = () => {
    if (listVisible) {
      toggle()
    }
  }

  return (
    <div className="flex flex-row rounded-md border border-grey-100">
      <div
        className={clsx(
          'px-4 flex items-center rounded-l-md cursor-pointer',
          listVisible ? 'bg-icon-semantic-black' : 'bg-icon-semantic-white',
        )}
        onClick={onListViewToggle}
        role="presentation"
      >
        <ListIcon
          className={clsx('w-5', listVisible ? 'text-icon-semantic-white' : 'text-icon-semantic-black')}
        ></ListIcon>
      </div>
      <div
        className={clsx(
          'px-4 flex items-center rounded-r-md cursor-pointer',
          calendarVisible ? 'bg-icon-semantic-black' : 'bg-icon-semantic-white',
        )}
        onClick={onCalendarViewToggle}
        role="presentation"
      >
        <CalendarIcon
          className={clsx('w-5', calendarVisible ? 'text-icon-semantic-white' : 'text-icon-semantic-black')}
        ></CalendarIcon>
      </div>
    </div>
  )
}

export default ViewToggle
